import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateTiposTbaiRegimen () {
  return [
    {
      label: i18n.t('tipos.tbai_regimen.01'),
      shortLabel: '01',
      value: '01'
    },
    {
      label: i18n.t('tipos.tbai_regimen.02'),
      shortLabel: '02',
      value: '02'
    },
    {
      label: i18n.t('tipos.tbai_regimen.03'),
      shortLabel: '03',
      value: '03'
    },
    {
      label: i18n.t('tipos.tbai_regimen.04'),
      shortLabel: '04',
      value: '04'
    },
    {
      label: i18n.t('tipos.tbai_regimen.05'),
      shortLabel: '05',
      value: '05'
    },
    {
      label: i18n.t('tipos.tbai_regimen.06'),
      shortLabel: '06',
      value: '06'
    },
    {
      label: i18n.t('tipos.tbai_regimen.07'),
      shortLabel: '07',
      value: '07'
    },
    {
      label: i18n.t('tipos.tbai_regimen.08'),
      shortLabel: '08',
      value: '08'
    },
    {
      label: i18n.t('tipos.tbai_regimen.09'),
      shortLabel: '09',
      value: '09'
    },
    {
      label: i18n.t('tipos.tbai_regimen.10'),
      shortLabel: '10',
      value: '10'
    },
    {
      label: i18n.t('tipos.tbai_regimen.11'),
      shortLabel: '11',
      value: '11'
    },
    {
      label: i18n.t('tipos.tbai_regimen.12'),
      shortLabel: '12',
      value: '12'
    },
    {
      label: i18n.t('tipos.tbai_regimen.13'),
      shortLabel: '13',
      value: '13'
    },
    {
      label: i18n.t('tipos.tbai_regimen.14'),
      shortLabel: '14',
      value: '14'
    },
    {
      label: i18n.t('tipos.tbai_regimen.15'),
      shortLabel: '15',
      value: '15'
    },
    {
      label: i18n.t('tipos.tbai_regimen.17'),
      shortLabel: '17',
      value: '17'
    },
    {
      label: i18n.t('tipos.tbai_regimen.19'),
      shortLabel: '19',
      value: '19'
    },
    {
      label: i18n.t('tipos.tbai_regimen.51'),
      shortLabel: '51',
      value: '51'
    },
    {
      label: i18n.t('tipos.tbai_regimen.52'),
      shortLabel: '52',
      value: '52'
    },
    {
      label: i18n.t('tipos.tbai_regimen.53'),
      shortLabel: '53',
      value: '53'
    },
    {
      label: i18n.t('tipos.tbai_regimen.54'),
      shortLabel: '54',
      value: '54'
    }
  ]
}

function GenerateTiposTbaiOperacion () {
  return [
    {
      label: i18n.t('tipos.tbai_operacion.s'),
      shortLabel: 'S',
      value: 'S'
    },
    {
      label: i18n.t('tipos.tbai_operacion.b'),
      shortLabel: 'B',
      value: 'B'
    }
  ]
}

function GenerateTiposTbaiNoExenta () {
  return [
    {
      label: i18n.t('tipos.tbai_no_exenta.s1'),
      shortLabel: 'S1',
      value: 'S1'
    },
    {
      label: i18n.t('tipos.tbai_no_exenta.s2'),
      shortLabel: 'S2',
      value: 'S2'
    }
  ]
}

function GenerateTiposTbaiNoSujeta () {
  return [
    {
      label: i18n.t('tipos.tbai_no_sujeta.ot'),
      shortLabel: 'OT',
      value: 'OT'
    },
    {
      label: i18n.t('tipos.tbai_no_sujeta.rl'),
      shortLabel: 'RL',
      value: 'RL'
    },
    {
      label: i18n.t('tipos.tbai_no_sujeta.vt'),
      shortLabel: 'VT',
      value: 'VT'
    },
    {
      label: i18n.t('tipos.tbai_no_sujeta.ie'),
      shortLabel: 'IE',
      value: 'IE'
    },
  ]
}

function GenerateTiposHacienda () {
  return [
    {
      label: i18n.t('tipos.hacienda.alava'),
      shortLabel: '3',
      value: '3'
    },
    {
      label: i18n.t('tipos.hacienda.vizcaya'),
      shortLabel: '1',
      value: '1'
    },
    {
      label: i18n.t('tipos.hacienda.guipuzcoa'),
      shortLabel: '2',
      value: '2'
    },
  ]
}

function GenerateTiposEstados () {
  return [
    {
      label: i18n.t('tipos.estado_TBAI.correcto'),
      shortLabel: '1',
      value: '1'
    },
    {
      label: i18n.t('tipos.estado_TBAI.aceptado_error'),
      shortLabel: '2',
      value: '2'
    },
    {
      label: i18n.t('tipos.estado_TBAI.rechazado'),
      shortLabel: '3',
      value: '3'
    },
    {
      label: i18n.t('tipos.estado_TBAI.pendiente'),
      shortLabel: '4',
      value: '4'
    },
    {
      label: i18n.t('tipos.estado_TBAI.generado'),
      shortLabel: '5',
      value: '5'
    }
  ]
}

function TIPOS_TBAI_REGIMEN (state) {
  return configHelper.getConfig(state, 'TIPOS_TBAI_REGIMEN', GenerateTiposTbaiRegimen)
}

function TIPOS_TBAI_OPERACION (state) {
  return configHelper.getConfig(state, 'TIPOS_TBAI_OPERACION', GenerateTiposTbaiOperacion)
}

function TIPOS_TBAI_NO_EXENTA (state) {
  return configHelper.getConfig(state, 'TIPOS_TBAI_NO_EXENTA', GenerateTiposTbaiNoExenta)
}

function TIPOS_TBAI_NO_SUJETA (state) {
  return configHelper.getConfig(state, 'TIPOS_TBAI_NO_SUJETA', GenerateTiposTbaiNoSujeta)
}

function TIPOS_HACIENDA (state) {
  return configHelper.getConfig(state, 'TIPOS_HACIENDA', GenerateTiposHacienda)
}
function TIPOS_ESTADOS_TBAI (state) {
  return configHelper.getConfig(state, 'TIPOS_ESTADOS_TBAI', GenerateTiposEstados)
}
  
export {
  TIPOS_TBAI_REGIMEN, TIPOS_TBAI_OPERACION, TIPOS_TBAI_NO_EXENTA, TIPOS_TBAI_NO_SUJETA, TIPOS_HACIENDA, TIPOS_ESTADOS_TBAI
}
